import { PlaybackState } from '../../../enums';
export const getPlaybackPauseState = (playbackState, currentCanPause) => {
    if (playbackState === PlaybackState.BUFFERING) {
        return {
            canPause: currentCanPause,
        };
    }
    return {
        canPause: playbackState === PlaybackState.PLAYING,
    };
};
